























import Vue from 'vue'
import confetti from 'canvas-confetti'

export default Vue.extend({
  name: 'CompletedOfferModal',

  props: {
    proofType: {
      type: Object,
      required: true,
    },
    businessBrand: {
      type: String,
      required: true,
    },
    completedOffersCount: {
      type: Number,
      required: true,
    },
    offerShortUrlId: {
      type: String,
      required: true,
    },
    offerSummary: {
      type: String,
      required: true,
    },
  },

  mounted: function () {
    confetti({
      zIndex: 1000,
      particleCount: 75,
    })
  },

  methods: {
    closeDialog() {
      this.$emit('completed-offer-modal-close')
    },

    handleSeeMoreOffers() {
      this.$router.push({ path: '/' })

      this.closeDialog()
    },
  },
})
